import { PersonBus } from "./PersonBus";
import { CustomerLogoBus } from "./CustomerLogoBus";
import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { v_InventoryBus } from "./v_InventoryBus";

export class CustomerInventoryBus extends BaseBus
{
    constructor(data: CustomerInventoryBus) {
        super(data);
    }

    CID(): any {
        return this.customerInventoryXREFId;
    }
    setId(id: any) {
        this.customerInventoryXREFId = id;
    }
    initialize(data: CustomerInventoryBus) {
        super.initialize(data);
        this.insertDt = CommonFunctions.getDate(data.insertDt);
        this.updateDt = CommonFunctions.getDate(data.updateDt);
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: CustomerInventoryBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();

        if (this.hasId) {
            //this.updateDt = dateNow;
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        // this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        if (this.hasId) {
            this.updateUserId = userId;
        }
        else {
            this.insertDt = date;
            this.insertUserId = userId;
             this.updateUserId = userId;
        }
    }

    changeInventoryItem(data: v_InventoryBus) {
        this.number = data.number;
        this.inventoryDesc = data.inventoryDesc;
        this.inventoryId = data.inventoryId;
        this.fullDescription = data.fullDescription;

        //this.quantity = 1;
        //this.qtyInStock = data..currentCost;
    }
        customerInventoryXREFId: string;
        inventoryId: string;
        customerId: string;
        price: number;
        number: string;
        fullDescription: string;
        inventoryDesc: string;
        insertDt: Date;
        updateDt: Date;
        updateUserId: string;
        insertUserId: string;
        createdUser : string;
        createdDt : string;
}
